<template>
  <refonte-modal
    v-bind:show="props.show"
    v-on:close="close"
    title="Activer cette entité"
    class="!max-w-[764px]">
    <template v-slot:modalBody>
      <div class="flex flex-col gap-[8px]">
        <span>
          <u
            >La réactivation d'une entité est effectuée par votre organisme de
            formation.</u
          >
        </span>
        <span> Selon votre situation : </span>
        <ul class="list-disc space-y-3 pl-6">
          <li>
            <strong>L'entité a été désactivée à tort :</strong>
            contactez votre organisme de formation, qui procédera à la
            réactivation. Les commandes seront de nouveau possibles pour cette
            entité.
          </li>
          <li>
            <strong
              >Le SIRET a changé (déménagement, nouvel établissement) :
            </strong>
            créez un nouvel établissement avec le nouveau SIRET.
          </li>
          <li>
            <strong>Vous avez quitté cette entité : </strong>demandez à un autre
            administrateur de vous retirer via le menu <em>Interlocuteurs</em>.
            Une entité doit toujours conserver au moins un administrateur.
          </li>
        </ul>
      </div>
    </template>
  </refonte-modal>
</template>

<script setup lang="ts">
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';

  const props = withDefaults(
    defineProps<{
      show: boolean;
      on_close: Function;
      class?: string;
    }>(),
    {
      class: ''
    }
  );

  function close() {
    props.on_close();
  }
</script>

<style lang="scss" scoped></style>
